import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Device, DataForCharts } from './statistics.model';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  public deviceArray: Subject<any> = new Subject();
  public sessionStat: number;//Subject<number> = new Subject();
  constructor() { }


  formatForNGXCharts(devices:Device[]):Device[]{

    let _devices:DataForCharts[] = []

    for ( let i:number = 0 ; i < devices.length ; i++){ 
      _devices.push ({
        name:devices[i].name,
        value:devices[i].sessions
      })
    }   


      return _devices

  }

}
